export class Archive {
    id: string;
    name: string;
    color: string;
    parent_id: string;
    
    creation_user: string;
    creation_ip: string;
    created_at: string;

    last_update_user:string;
    last_update_ip:string;
    on_behalf_of:string;
    last_on_behalf_of:string;
    showDeletedOnly: boolean;

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./src/app/views/setting/archive/archive.ts